import { LimitPeriod } from '../data-types/profile/profile-sections/staying-in-control/stayingInControlEnums';
import { LimitTimeFrame } from '../data-types/profile/profile-sections/staying-in-control/stayingInControlInterfaces';
import { capitalizeFirstCharOfText } from './general';

export const convertToTitle = (timeFrames: LimitTimeFrame[], period: number): string | undefined => {
  const timePeriod = timeFrames.find(item => item.key === period);
  if (timePeriod) {
    return timePeriod.titleId;
  }
  return;
};

export const convertToPeriod = (timeFrameId: string, periods: LimitTimeFrame[]): number | null => {
  const period = periods.find(item => item.titleId === timeFrameId);
  if (period) {
    return period.key;
  }
  return null;
};

export const getFullPeriodNameId = (timePeriod: LimitPeriod): string => {
  switch (timePeriod) {
    case LimitPeriod.DAY:
      return 'limit.daily';
    case LimitPeriod.WEEK:
      return 'limit.weekly';
    case LimitPeriod.MONTH:
      return 'limit.monthly';
    default:
      return '';
  }
};

export const computeTimePeriodTitle = (period: string, limitType: string) => {
  return `${capitalizeFirstCharOfText(period)} ${capitalizeFirstCharOfText(limitType)} Limit`;
};

export const getPeriodDuration = (period: string, timeoutDays: number) => {
  switch (parseInt(period, 10)) {
    case LimitPeriod.DAY:
      return '1-d';
    case LimitPeriod.WEEK:
      return '1-w';
    case LimitPeriod.MONTH:
      return '1-m';
    case LimitPeriod.CUSTOM:
      return `${timeoutDays}-d`;
    default:
      return '';
  }
};
